import Avatar from "@mui/material/Avatar";
import { Link, useLocation } from "react-router-dom";
import BrandLogo from "../../assets/images/brand-logo.svg";
import { Divider,Menu,MenuItem,Tooltip} from "@mui/material";
import { getSessionData, stringAvatar } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginRedirect from "../controls/Modals/loginRedirect";
import LogoutLogo from "../../assets/icons/logout-outline.svg";
import { ToastHelper } from "../../utils/toastHelper";
import  Notification  from "./notification";

const Header = () => {
  const [idleTime, setIdleTime] = useState(0);
  const idleTimeout = 1200000;
  const sessionKey = "sessionData";
  const [open, setOpen] = useState(false);
  const [remainingTime, setRemainingTime] = useState(300);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();
  const userInfo = getSessionData();
  const location = useLocation();
  const isUnauthorized =  location.pathname === "/unauthorized";
   
  useEffect(() => {
    if (!userInfo) navigate("/");
  },[userInfo, navigate]);

  useEffect(() => {
    const resetIdleTime = () => setIdleTime(0);

    window.addEventListener("mousemove", resetIdleTime);
    window.addEventListener("keydown", resetIdleTime);
    window.addEventListener("click", resetIdleTime);

    const idleInterval = setInterval(() => {
      setIdleTime((prevIdleTime) => {
        if (prevIdleTime >= idleTimeout - 300000) {
          setOpen(true);
          setRemainingTime(Math.ceil((idleTimeout - prevIdleTime) / 1000));
        }
        return prevIdleTime + 1000;
      });
    }, 1000);

    if (idleTime >= idleTimeout) {
      handleLogout();
    }

    return () => {
      window.removeEventListener("mousemove", resetIdleTime);
      window.removeEventListener("keydown", resetIdleTime);
      window.removeEventListener("click", resetIdleTime);

      clearInterval(idleInterval);
    };
  }, [idleTime]);

  const handleLogout = () => {
    setOpen(true);
  };


  const userLogOutSession = () => {
    const toastHelper = new ToastHelper(true, "Please wait...");

    toastHelper.updateToast({
      severity: "info",
      content: "Logging out...",
      options: {
        isLoading: true,
        position: "top-center",
        autoClose: 10000,
      },
    });

    sessionStorage.removeItem(sessionKey);
    navigate("/");

    toastHelper.updateToast({
      severity: "success",
      title: "You have been logged out!",
      content: "",
      showClose: false,
      options: {
        position: "top-center",
        autoClose: 7000,
      },
    });
  };

  const isSessionActive = () => {
    const session = getSessionData();
    return session ? true : false;
  };

  useEffect(() => {
    if (!isSessionActive()) {
      navigate("/");
    }
  }, [navigate]);

  const resetSession = () => {
    setIdleTime(0);
    setOpen(false);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  return (
    <>
      <header className={`ts-header`}>
        <div className="ts-header-container">
          <div className="ts-header-container-navbar">
            <div className="ts-header-container-navbar-left">
              <div className="ts-header-continer-navbar-brand-logo">
                <Link to="/welcome">
                  <img className="brandLogo" src={BrandLogo} alt="Roche" />
                </Link>
              </div>
              <Divider orientation="vertical" variant="middle" flexItem />
              <div className="ts-header-continer-navbar-brand-name">
                Text Sentinel
              </div>
            </div>
            <div className="ts-header-container-navbar-right">
              <div className="ts-header-container-navbar-right-content">
                {!isUnauthorized && <Notification /> }
                <Tooltip title="Logout">
                  <img
                    className="logoutIcon"
                    src={LogoutLogo}
                    alt="Logout"
                    onClick={userLogOutSession}
                  />
                </Tooltip>
                <Tooltip title={userInfo?.firstName + " " + userInfo?.lastName}>
                  <Avatar 
                    onClick={handleOpenUserMenu}
                    style={{ fontSize: "15px" }}
                    {...stringAvatar(
                      userInfo?.firstName + " " + userInfo?.lastName
                    )}
                  />
                </Tooltip>
                {userInfo?.role==="TextSentinel_profile_group_admin"? 
                  <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    <MenuItem onClick={handleCloseUserMenu}>
                      <Link to="/auditLogs" style={{ textDecoration: "none", color:"#0050b6" }}>
                        Audit Log Report
                      </Link>
                    </MenuItem>
                  </Menu>:null
                }
              </div>
            </div>
          </div>
        </div>
      </header>
      <LoginRedirect
        open={open}
        remainingTime={remainingTime}
        resetSession={resetSession}
      />
    </>
  );
};

export default Header;
